import type { Branch, DailySale } from './domain';

const money = new Intl.NumberFormat('th-TH', { maximumFractionDigits: 2 });

export function thaiDisplayDate(date: string) {
  return new Intl.DateTimeFormat('th-TH', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Asia/Bangkok' }).format(new Date(`${date}T12:00:00+07:00`));
}

export function buildReport(branches: Branch[], sales: DailySale[], date: string) {
  const active = branches.filter((branch) => branch.isActive).sort((a, b) => a.sortOrder - b.sortOrder);
  const byBranch = new Map(sales.filter((sale) => sale.salesDate === date).map((sale) => [sale.branchId, sale]));
  const regionTotals = new Map<string, number>();
  let total = 0;
  const lines = [`สรุปยอดประจำวันที่ ${thaiDisplayDate(date)}`, ''];

  active.forEach((branch, index) => {
    const sale = byBranch.get(branch.id);
    const amount = sale?.salesAmount ?? 0;
    total += amount;
    regionTotals.set(branch.region, (regionTotals.get(branch.region) ?? 0) + amount);
    const mark = (ok: boolean | undefined, yes: string, no: string) => `${ok ? '✅' : '❌'}${ok ? yes : no}`;
    lines.push(
      `${index + 1}. สาขา${branch.name}`,
      `💵 ยอดวันนี้ ${money.format(amount)} บาท`,
      mark(sale?.paidComplete, 'โอนครบ', 'โอนไม่ครบ'),
      mark(sale?.posComplete, 'POSครบ', 'POSไม่ครบ'),
      mark(sale?.billComplete, 'บิลครบ', 'บิลไม่ครบ'),
      mark(sale?.stockAttached, 'แนบสต๊อกแล้ว', 'ยังไม่แนบสต๊อก'),
      mark(sale?.salesLinkUpdated, 'ยอดขายลงในลิงค์แล้ว', 'ยังไม่ลงยอดขายในลิงค์'),
      mark(sale?.dailyInspectionAttached, 'แนบใบตรวจเช็คสาขารายวันแล้ว', 'ยังไม่แนบใบตรวจเช็คสาขารายวัน'),
      mark(sale?.unpluggedPhotoConfirmed, 'แนบรูปถอดปลั๊กไฟเรียบร้อย', 'ยังไม่แนบรูปถอดปลั๊กไฟ'),
      ''
    );
  });

  lines.push(`💷 ยอดขายรวม : ${money.format(total)} บาท`, '', '👑 สรุปรวมตามโซนภาค');
  for (const [region, amount] of regionTotals) lines.push(`📍${region}: ${money.format(amount)} บาท`);
  return lines.join('\n').trim();
}

export function totalsByRegion(sales: DailySale[]) {
  const totals = new Map<string, number>();
  for (const sale of sales) totals.set(sale.regionSnapshot, (totals.get(sale.regionSnapshot) ?? 0) + (sale.salesAmount ?? 0));
  return [...totals].sort((a, b) => b[1] - a[1]);
}
